import {register} from '../vendor/theme-scripts/theme-sections';
import {modal} from '../util/modal';
import {ellipsis} from '../util/ellipsis';
import Media from '../features/media';
import {RadioSwatch} from '../features/swatch';
import pickupAvailability from '../features/pickup-availability';
import {ProductForm} from '../features/product-form';
import {ProductComplimentary} from '../features/product-complimentary';
import {productPhotoswipeZoom} from '../features/load-photoswipe';
import {PopoutSelect} from '../features/popout';
import tabs from '../features/tabs';
import hideElement from '../util/hide-element';
import showElement from '../util/show-element';
import {accordion} from '../features/accordion';
import {swapperSection} from '../features/swapper';
import {ShareButton} from '../features/share';
import {GroupVariantImages} from '../features/variant-group-images';
import {ImageCaption} from '../features/image-caption';

const selectors = {
  productJson: '[data-product-json]',
  zoomButton: '[data-zoom-button]',
  toggleTruncateHolder: '[data-truncated-holder]',
  toggleTruncateButton: '[data-truncated-button]',
  toggleTruncateContent: 'data-truncated-content',
};

const classes = {
  classExpanded: 'is-expanded',
  classVisible: 'is-visible',
};

const sections = [];

class ProductTemplate {
  constructor(section) {
    this.section = section;
    this.id = section.id;
    this.container = section.container;
    this.settings = section.settings;

    modal(this.id);
    this.media = new Media(section);
    new GroupVariantImages(section);

    const productJSON = this.container.querySelector(selectors.productJson);
    if (productJSON && productJSON.innerHTML !== '') {
      this.product = JSON.parse(productJSON.innerHTML);
    } else {
      console.error('Missing product JSON');
      return;
    }

    this.truncateElementHolder = this.container.querySelector(selectors.toggleTruncateHolder);
    this.truncateElement = this.container.querySelector(`[${selectors.toggleTruncateContent}]`);
    this.resizeEventTruncate = () => this.truncateText();

    this.init();
  }

  init() {
    this.zoomEnabled = this.container.querySelector(selectors.zoomButton) !== null;
    if (this.zoomEnabled) {
      productPhotoswipeZoom(this.container, this.product);
    }

    if (this.truncateElementHolder && this.truncateElement) {
      setTimeout(this.resizeEventTruncate, 50);
      document.addEventListener('theme:resize', this.resizeEventTruncate);
    }

    new ImageCaption(this.container);
  }

  truncateText() {
    if (this.truncateElementHolder.classList.contains(classes.classVisible)) return;
    const styles = this.truncateElement.querySelectorAll('style');
    if (styles.length) {
      styles.forEach((style) => {
        this.truncateElementHolder.prepend(style);
      });
    }

    const truncateElementCloned = this.truncateElement.cloneNode(true);
    const truncateElementClass = this.truncateElement.getAttribute(selectors.toggleTruncateContent);
    const truncateNextElement = this.truncateElement.nextElementSibling;
    if (truncateNextElement) {
      truncateNextElement.remove();
    }

    this.truncateElement.parentElement.append(truncateElementCloned);

    const truncateAppendedElement = this.truncateElement.nextElementSibling;
    truncateAppendedElement.classList.add(truncateElementClass);
    truncateAppendedElement.removeAttribute(selectors.toggleTruncateContent);

    showElement(truncateAppendedElement);

    ellipsis(truncateAppendedElement, 5, {
      replaceStr: '',
      delimiter: ' ',
    });

    hideElement(truncateAppendedElement);

    if (this.truncateElement.innerHTML !== truncateAppendedElement.innerHTML) {
      this.truncateElementHolder.classList.add(classes.classExpanded);
    } else {
      truncateAppendedElement.remove();
      this.truncateElementHolder.classList.remove(classes.classExpanded);
    }

    this.toggleTruncatedContent(this.truncateElementHolder);
  }

  toggleTruncatedContent(holder) {
    const toggleButton = holder.querySelector(selectors.toggleTruncateButton);
    if (toggleButton) {
      toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        holder.classList.remove(classes.classExpanded);
        holder.classList.add(classes.classVisible);
      });
    }
  }

  onBlockSelect(event) {
    const block = this.container.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (block) {
      block.dispatchEvent(new Event('click'));
    }
  }

  onBlockDeselect(event) {
    const block = this.container.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (block) {
      block.dispatchEvent(new Event('click'));
    }
  }

  onUnload() {
    this.media.destroy();
    if (this.truncateElementHolder && this.truncateElement) {
      document.removeEventListener('theme:resize', this.resizeEventTruncate);
    }
  }
}

const productSection = {
  onLoad() {
    sections[this.id] = new ProductTemplate(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
  onBlockSelect(evt) {
    if (typeof sections[this.id].onBlockSelect === 'function') {
      sections[this.id].onBlockSelect(evt);
    }
  },
  onBlockDeselect(evt) {
    if (typeof sections[this.id].onBlockDeselect === 'function') {
      sections[this.id].onBlockDeselect(evt);
    }
  },
};

register('product', [productSection, pickupAvailability, accordion, tabs, swapperSection]);

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}

if (!customElements.get('product-complimentary')) {
  customElements.define('product-complimentary', ProductComplimentary);
}

if (!customElements.get('radio-swatch')) {
  customElements.define('radio-swatch', RadioSwatch);
}

if (!customElements.get('popout-select')) {
  customElements.define('popout-select', PopoutSelect);
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton);
}
